// const env = process.env.NODE_ENV
const env = import.meta.env.VITE_APP_MODE

export const isDev = env === 'development'

export const isProd = env === 'production'